module.exports = __webpack_public_path__ + "assets/igodigital.a018ffbe.svg";